import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect';
import { replace } from '../services/router-utils';

const requireNotBlocked = connectedReduxRedirect({
  authenticatedSelector: state => !state.auth.currentUser.isBlocked,
  redirectPath: '/account-suspended',
  wrapperDisplayName: 'requireNotBlocked',
  redirectAction: replace,
  allowRedirectBack: false,
});

export default requireNotBlocked;
